export const TEAM_ID_LOCAL_STORAGE = 'codesandbox-selected-team-id';
